import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  id: null,
  createdAt: null,
  email: '',
  name: '',
  avatarUrl: null,
  telegramUrl: null,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserId: (state, action) => { state.id = action.payload },
    setUserCreatedAt: (state, action) => { state.createdAt = action.payload },
    setUserEmail: (state, action) => { state.email = action.payload },
    setUserName: (state, action) => { state.name = action.payload },
    setUserAvatar: (state, action) => { state.avatarUrl = action.payload },
    setUserTelegram: (state, action) => { state.telegramUrl = action.payload },

    resetUser: () => initialState,
  },
})

export const {
  setUserId,
  setUserCreatedAt,
  setUserEmail,
  setUserName,
  setUserAvatar,
  setUserTelegram,

  resetUser,
} = userSlice.actions

export default userSlice.reducer
